import styled from '@emotion/styled';
import { colors } from '@/constants/colors';

type DividerProps = {
  color?: string,
  vertical?: boolean,
  opacity?: number,
  size?: string,
  thick?: number,
  margin?: string,
};

const Divider = styled.div<DividerProps>`
  width: ${({ vertical, size, thick = 1 }) => vertical ? `${thick}px` : size ?? '100%'};
  height: ${({ vertical, size, thick = 1 }) => vertical ? size ?? '100%' : `${thick}px`};
  margin: ${({ margin }) => margin};
  background-color: ${({ color }) => color ? color : colors.black100};
  opacity: ${({ opacity }) => opacity};
`;

export default Divider;
